import { render, staticRenderFns } from "./BackNavigationItem.vue?vue&type=template&id=2c07f4d4&scoped=true&"
import script from "./BackNavigationItem.vue?vue&type=script&lang=js&"
export * from "./BackNavigationItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c07f4d4",
  null
  
)

export default component.exports